/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Changes_1Inputs */

const da_terms_changes_1 = /** @type {(inputs: Terms_Changes_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi kan ændre priser og betingelser med mindst 30 dages varsel på e-mail. Ændringer gælder fra næste betalingsperiode.`)
};

/** @type {(inputs: Terms_Changes_1Inputs) => LocalizedString} */
const en_terms_changes_1 = da_terms_changes_1;

/**

* @param {Terms_Changes_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_changes_1 = /** @type {((inputs?: Terms_Changes_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Changes_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_changes_1(inputs)
	return /** @type {LocalizedString} */ ("Vi kan ændre priser og betingelser med mindst 30 dages varsel på e-mail. Ændringer gælder fra næste betalingsperiode.")
});